import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { AddBankInfo } from '@/features/payment-management/admin-payment-setup/AddBankInfo';
import { Translation } from '@/hoslog-intl';
import { SettingIcon } from '@/icons';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/payment-management/admin-payment-setup/add-bank-information')({
  loader: () => ({
    crumb: <CrumbTitle id="paymentManagement.sidebar.menu.adminPaymentSetup" icon={SettingIcon} />,
    title: <Translation id="paymentManagement.sidebar.menu.adminPaymentSetup" />,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <AddBankInfo />;
}
